import React from 'react';

import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

const loading = (props) => {
  let classes = ['loading-spinner'];
  if(props.blocking){
    classes.push('blocking');
  };
  if(props.centered){
    classes.push('centered')
  };
  return (
    <div className={ classes.join(' ') }>
      <Spinner size={SpinnerSize.large} label={props.label || "Loading..."} />
    </div>
  )
};

export default loading;


// WEBPACK FOOTER //
// ./src/components/loading.js